<template>
  <div class="w-full border border-2 p-1 rounded-lg h-[17rem]">
    <div class="d-flex gap-4">
      <div class="bg-[#DFF3FF] rounded py-[2px] px-[4px]">
        <span class="k-truck text-[#08A0F7] text-3xl" />
      </div>
      <span class="font-semibold align-self-center text-[16px] text-[#626262]">JUMLAH PENGIRIMAN</span>
      <span
        id="tooltip-count-send"
        class="k-info-circle align-self-center text-xl text-[#08A0F7]"
      />
      <b-tooltip
        target="tooltip-count-send"
        triggers="hover"
        variant="light"
      >
        <div class="text-start">
          <div class="mb-1">
            <b>Jumlah Pengiriman</b>
          </div>
          <div>
            Jumlah orderan yang dibuat di bulan yg dipilih yang berstatus "Dibuat", "Dipacking", "Dikirim", "Diterima", "Retur" (retur dalam perjalanan dan retur selesai), "Hilang", "Rusak” sesuai filter ekspedisi yang dipilih
          </div>
        </div>
      </b-tooltip>
    </div>
    <div class="font-semibold text-3xl mt-1 pl-1 text-black">
      <b-spinner
        v-if="count === null"
        small
        variant="primary"
      />
      <span v-else>{{ count }}</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    date: {
      type: String,
      default: null,
    },
    shipping: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      count: null,
    }
  },
  watch: {
    date(newVal) {
      if (newVal !== null) {
        this.getCount()
      }
    },
    shipping(newVal) {
      if (newVal !== null) {
        this.getCount()
      }
    },
  },
  mounted() {
    this.getCount()
  },
  methods: {
    getCount() {
      const url = '/komship/api/v1/delivery-insight'
      const params = {
        metric: 'total',
        date: this.date,
        shipping: this.shipping.shipping_name,
      }
      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.count = data.count
          this.$emit('update', this.count)
        })
        .catch(res => {
          this.$toast_error({ message: 'Gagal Mendapatkan Data Jumlah Pengiriman' })
        })
    },
  },
}
</script>
